var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 20,
    cy: 20,
    r: 20,
    opacity: 0.39
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-expand",
    "data-name": "Icon awesome-expand",
    d: "M0,7.932V3.171A.919.919,0,0,1,.921,2.25H5.682a.462.462,0,0,1,.461.461V4.246a.462.462,0,0,1-.461.461H2.457V7.932A.462.462,0,0,1,2,8.393H.461A.462.462,0,0,1,0,7.932ZM11.057,2.711V4.246a.462.462,0,0,0,.461.461h3.225V7.932a.462.462,0,0,0,.461.461h1.536a.462.462,0,0,0,.461-.461V3.171a.919.919,0,0,0-.921-.921H11.518A.462.462,0,0,0,11.057,2.711Zm5.682,10.6H15.2a.462.462,0,0,0-.461.461v3.225H11.518a.462.462,0,0,0-.461.461v1.536a.462.462,0,0,0,.461.461h4.761a.919.919,0,0,0,.921-.921V13.768A.462.462,0,0,0,16.739,13.307Zm-10.6,5.682V17.454a.462.462,0,0,0-.461-.461H2.457V13.768A.462.462,0,0,0,2,13.307H.461A.462.462,0,0,0,0,13.768v4.761a.919.919,0,0,0,.921.921H5.682A.462.462,0,0,0,6.143,18.989Z",
    transform: "translate(11.532 9.123)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.765c991715b1ca1cdf4d955e841c1228.svg";
export { ForwardRef as ReactComponent };